import ICompany from '~/interfaces/ICompany';
import { Realtime } from '~/services/firebase';
import ITable from '~/interfaces/ITable';

type NotifyProps = {
  table: ITable;
  company: ICompany;
  order: any;
};

export function notifyTableOrder({ company, table, order }: NotifyProps): void {
  const notification = {
    type: '0',
    description: `A mesa ${table.name} realizou um pedido!`,
    link: `/table-orders`,
    company_id: company.uid,
    user_id: company.user_id,
    created_at: new Date(),
    order,
    notPrintTableParcial: true,
  };

  const notificationsRef = Realtime.ref(`notifications/${company.user_id}`);
  const newNotificationRef = notificationsRef.push();
  newNotificationRef.set(notification);
}
